import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { TemplateGeneratorComponent } from './template-generator/template-generator.component';
import { TEMPLATE_WIDGETS } from './service/template-tokens';
import { templateArrayToObj } from './service/template-widgets';
import { TemplateLoaderService } from './service/template-loader.service';
import { CmsModuleResolverService } from './service/cms-module-resolver.service';
import { MemberLoadingCultureCenterComponent } from 'src/app/member/module/culture-center-member/member-loading-culture-center/member-loading-culture-center.component';
import { NotFoundComponent } from './component/not-found/not-found.component';
import { SignOutComponent } from 'src/app/member/component/sign-out/sign-out.component';
import { TemplateApplyGuardService } from '../../share/service/template-apply-guard.service';


export const routes: Routes = [
  {
    path: '', component: TemplateGeneratorComponent, children: [
      { path: '404', loadChildren: () => import('../../not-found/not-found.module').then(mod => mod.NotFoundModule), data: {}, canActivate: [TemplateApplyGuardService] },
      { path: 'sitemap', loadChildren: () => import('../../sitemap/sitemap.module').then(mod => mod.SitemapModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService] },
      // { path: 'theme', loadChildren: () => import('../../theme-sites/theme-sites.module').then(mod => mod.ThemeSitesModule) },
      { path: 'signInCallBack', component: MemberLoadingCultureCenterComponent, data: {}, canActivate: [TemplateApplyGuardService] },
      { path: 'signOut', component: SignOutComponent, data: {}, canActivate: [TemplateApplyGuardService] },
      { path: 'memberCollection', loadChildren: () => import('../../member-collections/member-collections.module').then(mod => mod.MemberCollectionsModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'datasearch', loadChildren: () => import('../../data-search/data-search.module').then(mod => mod.DataSearchModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'subject/:id', loadChildren: () => import('../subject-generator/subject-generator.module').then(mod => mod.SubjectGeneratorModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'subject', pathMatch: 'full', loadChildren: () => import('../../subject/subject.module').then(mod => mod.SubjectModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'participate/:id', loadChildren: () => import('../subject-generator/subject-generator.module').then(mod => mod.SubjectGeneratorModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'participate', pathMatch: 'full', loadChildren: () => import('../../participate/participate.module').then(mod => mod.ParticipateModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'explore', pathMatch: 'full', loadChildren: () => import('../../explore/explore.module').then(mod => mod.ExploreModule), data: {}, canActivate: [TemplateApplyGuardService]  },
      { path: 'detail', loadChildren: () => import('../../detail/detail.module').then(mod => mod.DetailModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'errorReport', loadChildren: () => import('../../error-report/error-report.module').then(mod => mod.ErrorReportModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      { path: 'interact', loadChildren: () => import('../../interact/interact.module').then(mod => mod.InteractModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
      {
        path: ':cmsType', resolve: { cmsModule: CmsModuleResolverService }, children: [
          // tslint:disable-next-line: max-line-length
          { path: ':id', loadChildren: () => import('../cms-detail-generator/cms-detail-generator.module').then(mod => mod.CmsDetailGeneratorModule), data: { applyTemplate: 'template-040' }, canActivate: [TemplateApplyGuardService]  },
          { path: '', loadChildren: () => import('../cms-generator/cms-generator.module').then(mod => mod.CmsGeneratorModule), data: { isCms: true }, canActivate: [TemplateApplyGuardService]  }
        ]
      },
      { path: '', loadChildren: () => import('../index-section-generator/index-section-generator.module').then(mod => mod.IndexSectionGeneratorModule), data: {}, canActivate: [TemplateApplyGuardService] },
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
  ],
  declarations: [
    TemplateGeneratorComponent,
    NotFoundComponent,
  ],
  exports: [
    RouterModule,
    TemplateGeneratorComponent,
  ],
  providers: [
    TemplateLoaderService,
    { provide: TEMPLATE_WIDGETS, useFactory: templateArrayToObj }
  ]
})
export class TemplateGeneratorModule { }
